/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MedicationReminderDuration } from './MedicationReminderDuration';
import {
    MedicationReminderDurationFromJSON,
    MedicationReminderDurationFromJSONTyped,
    MedicationReminderDurationToJSON,
} from './MedicationReminderDuration';
import type { MedicationReminderWhen } from './MedicationReminderWhen';
import {
    MedicationReminderWhenFromJSON,
    MedicationReminderWhenFromJSONTyped,
    MedicationReminderWhenToJSON,
} from './MedicationReminderWhen';

/**
 * 
 * @export
 * @interface MedicationReminderPhase
 */
export interface MedicationReminderPhase {
    /**
     * 
     * @type {Array<MedicationReminderWhen>}
     * @memberof MedicationReminderPhase
     */
    when: Array<MedicationReminderWhen>;
    /**
     * 
     * @type {MedicationReminderDuration}
     * @memberof MedicationReminderPhase
     */
    duration: MedicationReminderDuration;
}

/**
 * Check if a given object implements the MedicationReminderPhase interface.
 */
export function instanceOfMedicationReminderPhase(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "when" in value;
    isInstance = isInstance && "duration" in value;

    return isInstance;
}

export function MedicationReminderPhaseFromJSON(json: any): MedicationReminderPhase {
    return MedicationReminderPhaseFromJSONTyped(json, false);
}

export function MedicationReminderPhaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicationReminderPhase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'when': ((json['when'] as Array<any>).map(MedicationReminderWhenFromJSON)),
        'duration': MedicationReminderDurationFromJSON(json['duration']),
    };
}

export function MedicationReminderPhaseToJSON(value?: MedicationReminderPhase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'when': ((value.when as Array<any>).map(MedicationReminderWhenToJSON)),
        'duration': MedicationReminderDurationToJSON(value.duration),
    };
}

